import { ReactNode } from 'react';
import { View, ViewProps } from 'react-native';
import { tv } from '@/common/theme/tv.config';
import {
  TGap,
  alignItemsVariants,
  columnGapVariants,
  gapVariants,
  justifyContentVariants,
  rowGapVariants,
} from '@/common/theme/variants';

export const Stack = ({
  horizontal,
  gap,
  rowGap,
  columnGap,
  align,
  justify,
  grow,
  wrap,
  shrink,
  className,
  children,
  ...viewProps
}: TStackProps) => {
  return (
    <View
      className={styles.root({
        horizontal,
        gap,
        rowGap,
        columnGap,
        align,
        justify,
        grow,
        wrap,
        shrink: shrink ?? horizontal,
        className,
      })}
      {...viewProps}
    >
      {children}
    </View>
  );
};

const styles = {
  root: tv({
    base: 'flex flex-col',
    variants: {
      horizontal: {
        true: 'flex-row',
      },
      gap: gapVariants,
      align: alignItemsVariants,
      justify: justifyContentVariants,
      rowGap: rowGapVariants,
      columnGap: columnGapVariants,
      grow: {
        true: 'flex-1',
      },
      wrap: {
        true: 'flex-wrap',
      },
      shrink: {
        true: 'shrink',
      },
    },
  }),
};

export type TStackProps = {
  className?: string;
  horizontal?: boolean;
  gap?: TGap;
  rowGap?: TGap;
  columnGap?: TGap;
  align?: keyof typeof alignItemsVariants;
  justify?: keyof typeof justifyContentVariants;
  grow?: boolean;
  wrap?: boolean;
  shrink?: boolean;
  children?: ReactNode;
} & ViewProps;
